
/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Inventory {

    import fld = LotCreationItemsRow.Fields;
    @Serenity.Decorators.registerClass()
    export class LotCreationItemsEditor extends _Ext.ItemGridEditor<LotCreationItemsRow> {


        protected getColumnsKey() { return "Inventory.LotCreationItems"; }
        protected getDialogType() { return LotCreationItemsDialog; }
        protected getLocalTextPrefix() { return LotCreationItemsRow.localTextPrefix; }
        protected form: LotCreationItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public DeptId: number; 
        public TotalItems: number;
        statement: string;

        // #endregion


        constructor(container: JQuery) {
            super(container);
            //this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: false });
        }



        //// #region Column Add -Remove
        //protected getColumns() {

        //    var columns = super.getColumns();

        //    var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
             
        //    //To Add Delete Button on Item Row
        //    columns.unshift({
        //        field: 'Delete Row',
        //        name: '',
        //        format: ctx => '<a class="inline-action delete-row" title="delete">' +
        //            '<i class="fa fa-trash-o text-red"></i></a>',
        //        width: 24,
        //        minWidth: 24,
        //        maxWidth: 24
        //    });

        //    return columns;
        //}

        // //#endregion

        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }
        //#region  ItemGrid Inline Editor
        // **** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);
            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Are you sure want to delete? ', () => {

                        var id = this.id(item);
                        this.TotalItems = this.view.getItems().length - 1;
                        this.view.deleteItem(id);

                    });
                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }

         

        //Set Data for New SKU Generated
        public setData(entity: LotCreationDetailsRow, _productid: number, AtbId: number, pieces: number, weight: number, stockid: number) {
            var x = entity;
          


            var StockIds = [];
            StockIds.push(stockid);
            //var BOM: Stock.StockItemBOMRow[];
            //Stock.StockItemBOMService.GetStockBOM({ StockIds: StockIds }, response => BOM = response.Entities, { async: false });


            var SKU = "";
            var LotNo = FormatHelper.GetFormats("Lot")
            var bomitems = [];
            //for (var j = 0; j < BOM.length; j++) {

            //    var Amount = 0
            //    if (BOM[j].CalcOnId != 3) {
            //        var wt = count > entity.Pieces ? BOM[j].Weight / count : BOM[j].Weight / entity.Pieces
            //        Amount = wt * BOM[j].BomRate;
            //    }
            //    else {
            //        var pcs = count > entity.Pieces ? BOM[j].Pieces / count : BOM[j].Pieces / entity.Pieces
            //        Amount = pcs * BOM[j].BomRate;
            //    }


            //    var bomitem: SKUItemBOMRow = {
            //        BomAmount: Amount,
            //        BOMAttributeId: BOM[j].BOMAttributeId,
            //        BomRate: BOM[j].BomRate,
            //        CalcOnId: BOM[j].CalcOnId,
            //        CertificateNo: BOM[j].CertificateNo,
            //        Lab: BOM[j].Lab,
            //        Pieces: count > entity.Pieces ? BOM[j].Pieces / count: BOM[j].Pieces/entity.Pieces,
            //        BOMProductId: BOM[j].BOMProductId,
            //        ProductCode: BOM[j].ProductCode,
            //        ProductId: BOM[j].ProductId,
            //        ItemTypeId: BOM[j].ItemTypeId,
            //        Remarks: BOM[j].Remarks,
            //        SettingId: BOM[j].SettingId,
            //        //StoneStatusId: BOM[j].StoneStatusId,
            //        Weight: count > entity.Pieces ? BOM[j].Weight / count: BOM[j].Weight / entity.Pieces,
            //        RefStockBomId: BOM[i].StockBomId,
            //        Purity: BOM[i].Purity,
            //        PureWeight: count > entity.Pieces ? BOM[i].PureWeight / count: BOM[i].PureWeight / entity.Pieces
            //    }
            //    bomitems.push(bomitem);

            //}

            var Rate = 0;
            var Amount = 0;
            //if (bomitems.length > 0) {
            //    bomitems.forEach(function (BOMItem) {
            //        Rate += BOMItem.BomAmount;
            //    })
            //}
            //else {
            Rate = entity.UnitRate;
            //}

            var item: LotCreationItemsRow = {
                ProductId: _productid,
                ProductCode: x.ProductCode,
                ProductName: x.ProductName,
                AttributeId: AtbId,
                CalcOnId: x.CalcOnId,
                CompanyId: x.CompanyId,
                DepartmentId: x.DepartmentId,
                SKU: SKU,
                Pieces: pieces,
                Weight: weight,
                NetWeight: x.NetWeight,
                Line_No: x.Line_No,
                ItemTypeId: x.ItemTypeId,
                ProductTypeId: x.ProductTypeId,
                CategoryId: x.CategoryId,
                SubCategoryId: x.SubCategoryId,
                BrandId: x.BrandId,
                SuperTypeId: x.SuperTypeId,
                CollectionId: x.CollectionId,
                KaratId: x.KaratId,
                UnitRate: Rate,
                DiamondPieces: x.DiamondPieces,
                DiamondAmount: x.DiamondAmount,
                DiamondWeight: x.DiamondWeight,
                OtherAmount: x.OtherWeight * Rate,
                OtherPieces: x.OtherPieces,
                OtherWeight: x.OtherWeight,
                StoneAmount: 0,
                StonePieces: x.StonePieces,
                StoneWeight: x.StoneWeight,
                BagNo: x.BagNo,
                CertificateNo: x.CertificateNo,
                RefTransId: entity.TransId,
                RefVoucherId: entity.VoucherTypeId,
                //BOMDetails: bomitems,
                PartyId: entity.PartyId,
                NetAmount: entity.CalcOnId != 3 ? Rate * x.NetWeight : Rate * 1,
                GrossAmount: (Rate * x.NetWeight),
                HasBom: x.HasBom,
                LotNo: LotNo,
                Lab: x.Lab,
                StockAllocation: false,
                Studded: x.Studded,
                Purity: x.Purity,
                PureWeight: x.NetWeight * x.Purity
            };
            //item.TransItemId = this.nextId++;
            item[this.getIdProperty()] = "`" + this.nextId++;
            this.view.addItem(item);


        }

        public setOldItems(entity: any[]) {
            for (var i = 0; i < entity.length; i++) {
                entity[i][this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(entity[i]);
            }
        } 
        protected getButtons() {
            let buttons = super.getButtons(); 
            return [];
        }
         
    }
}